import { useEffect, useState } from "react";
import InstructorAssignedCourses from "../../../Components/InstructorsModule/InstructorAssignedCourses";
import ProfileSection from "../../../Components/ProfileSection";
import PageTitle from "../../../Components/UI/PageTitle";
import { getInstructorDetails } from "../../../apis";
import Loader from "../../../Components/Loader";
import ErrorAnimationComponent from "../../../assets/lottie/ErrorAnimation/ErrorAnimationComponent";
import { useParams } from "react-router-dom";
import { transformKeys } from "../../../_helper";

const InstructorDetails = () => {
  const { instructorId } = useParams();
  const [instructorData, setInstructorData] = useState({});
  const [assignedCourses, setAssignedCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  useEffect(() => {
    setLoading(true);
    getInstructorDetails(instructorId)
      .then((response) => {
        setInstructorData(response.data.data.personalData);
        setAssignedCourses(response.data.data.assignedCourses);
        console.log(response);
      })
      .catch((error) => {
        console.log(error);
        setError(error?.message || "Error while get instructor details");
      })
      .finally(() => {
        setLoading(false);
      });
  }, [instructorId]);

  const handleData = {
    ...transformKeys(instructorData || {}),
  };
  delete handleData?.id;
  delete handleData?.image;
  handleData.is_active = +handleData.is_active === 1 ? "Yes" : "No";

  if (loading) return <Loader />;
  if (error) return <ErrorAnimationComponent message={error} />;
  return (
    <>
      <PageTitle
        title={"Instructor Details"}
        BreadcrumbItems={[
          {
            title: "Home",
            link: "/",
          },
          {
            title: "Instructors Management",
            link: "/instructors-management",
          },
          {
            title: "Instructor Details",
          },
        ]}
      />
      <div className="tw-flex tw-flex-col tw-gap-4">
        <ProfileSection
          title="Personal Data"
          data={handleData || {}}
          img={instructorData?.image || ""}
        />
        <InstructorAssignedCourses
          data={assignedCourses || []}
          title="Assigned Courses "
        />
      </div>
    </>
  );
};

export default InstructorDetails;
